import { Verdict } from '@exam-center/graphql';
import { VerdictResultLabel } from '@exam-center/proctor-request-management';
import { Box, EventAvailableOutlinedIcon, Flex, Text } from '@shared/components';

interface ProctorRequestVerdictCardProps {
  comment: string;
  submittedAt: string;
  verdict: Verdict;
}

export default function ProctorRequestVerdictCard(props: Readonly<ProctorRequestVerdictCardProps>) {
  const { comment, submittedAt, verdict } = props;

  return (
    <Box
      sx={(theme) => ({
        p: theme.spacing(4),
        border: '1px solid',
        borderColor: theme.palette.divider,
        borderRadius: theme.shape.rounded(2),
      })}
    >
      <Flex
        sx={(theme) => ({
          borderLeft: '4px solid',
          pl: theme.spacing(4),
          borderColor:
            verdict === Verdict.Approved ? theme.palette.success.main : theme.palette.error.main,
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        })}
      >
        <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(2) }}>
          <Text variant='body1' color='text.secondary'>
            <Text component='span' sx={{ fontWeight: 'bold' }} variant='inherit'>
              ความคิดเห็นเพิ่มเติม:
            </Text>{' '}
            <Text component='span' variant='inherit'>
              {comment}
            </Text>
          </Text>
          <Flex sx={{ gap: (theme) => theme.spacing(1), alignItems: 'center' }}>
            <EventAvailableOutlinedIcon
              sx={{ color: (theme) => theme.palette.text.secondary, fontSize: '16px' }}
            />
            <Text variant='body2' color='text.secondary'>
              วันที่ไม่อนุมัติ: {submittedAt}
            </Text>
          </Flex>
        </Flex>
        <VerdictResultLabel variant={verdict} />
      </Flex>
    </Box>
  );
}
